import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const AdminSettingsContext = createContext();

export const useAdminSettings = () => {
  const context = useContext(AdminSettingsContext);
  if (!context) {
    throw new Error('useAdminSettings deve ser usado dentro de um AdminSettingsProvider');
  }
  return context;
};

export const AdminSettingsProvider = ({ children }) => {
  const { user } = useAuth();
  const [settings, setSettings] = useState({
    missionsVisible: false // Por padrão, missões ficam invisíveis
  });
  const [loading, setLoading] = useState(true);

  // Carregar configurações do backend apenas se for administrador
  useEffect(() => {
    if (user?.role === 'administracao') {
      loadSettings();
    } else {
      setLoading(false);
    }
  }, [user]);

  const loadSettings = async () => {
    try {
      const response = await api.get('/admin/settings');
      setSettings(response.data);
    } catch (error) {
      // Só mostrar erro se for um erro inesperado (não de autenticação)
      if (error.response?.status !== 401 && error.response?.status !== 403) {
        console.error('Erro ao carregar configurações:', error);
      }
      // Se não conseguir carregar, manter configurações padrão
    } finally {
      setLoading(false);
    }
  };

  const updateSetting = async (key, value) => {
    try {
      const newSettings = { ...settings, [key]: value };
      await api.put('/admin/settings', newSettings);
      setSettings(newSettings);
      return true;
    } catch (error) {
      console.error('Erro ao atualizar configuração:', error);
      return false;
    }
  };

  const toggleMissionsVisibility = async () => {
    const newValue = !settings.missionsVisible;
    const success = await updateSetting('missionsVisible', newValue);
    return success;
  };

  const value = {
    settings,
    loading,
    updateSetting,
    toggleMissionsVisibility,
    canManageSettings: user?.role === 'administracao'
  };

  return (
    <AdminSettingsContext.Provider value={value}>
      {children}
    </AdminSettingsContext.Provider>
  );
};
